import { render, staticRenderFns } from "./FollowProducts.vue?vue&type=template&id=ed64a11c&scoped=true&"
import script from "./FollowProducts.vue?vue&type=script&lang=js&"
export * from "./FollowProducts.vue?vue&type=script&lang=js&"
import style0 from "./FollowProducts.vue?vue&type=style&index=0&id=ed64a11c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed64a11c",
  null
  
)

export default component.exports